import { createI18n } from "vue-i18n";
import { useAppStoreHook } from "@/store/modules/app";
// 多语言文案唯一数据源:扁平 key 命名(模块_字段,如 agentList_username),
// 对齐 mall-app 设计;校验工具: node scripts/check-i18n.mjs (npm run check:i18n)
import messages from "./i18n-data.json";

const appStore = useAppStoreHook();

const i18n = createI18n({
  legacy: false,
  locale: appStore.language,
  messages: messages,
  globalInjection: true,
});

export default i18n;
